module.exports = __webpack_public_path__ + "7890b045ff071b97d15eca3ffdd2e3e8.png";